<template>
  <div class="news">
    <section class="primary">
      <h1>{{ post.title.rendered }}</h1>
      <time :datetime="post.date">{{ formatDate(post.date) }}</time>
      <img
        v-if="post.thumbnail.url"
        :src="post.thumbnail.url"
        :alt="post.title.rendered"
      />
      <img
        v-else
        src="@/assets/images/common/noimg.jpg"
        :alt="post.title.rendered"
      />
      <div v-html="post.content.rendered" class="content wp-content"></div>
      <h2>その他新着ニュース</h2>
      <div class="list">
        <NewsLists :lists="lists" />
      </div>
    </section>
    <div class="secondary">
      <NewsArchive />
    </div>
  </div>
</template>

<script lang="ts">
import { ref, watch } from 'vue'
import { useRoute } from 'vue-router'

import NewsLists from '@/components/block/NewsLists_OUTDATED.vue'
import NewsArchive from '@/components/block/NewsArchive.vue'

import { axiosSetting } from '@/utils/axiosSetting'

import '@/styles/wp-content.scss'

export default {
  name: 'NewsDetail',
  components: {
    NewsLists,
    NewsArchive
  },
  beforeRouteEnter: async (to: any) => {
    const ajax = axiosSetting('cms', 'block')

    const data = await ajax
      .get(`${process.env.VUE_APP_WPAPI_URL}wp-json/wp/v2/news/${to.params.id}`)
      .then((res) => {
        return res.data
      })

    to.meta.breadCrumb.splice(1)

    to.meta.breadCrumb.push({ label: data.title.rendered })
    document.title = `${data.title.rendered} | ${document.title}`
  },
  beforeRouteUpdate: async (to: any) => {
    const ajax = axiosSetting('cms', 'block')

    const data = await ajax
      .get(`${process.env.VUE_APP_WPAPI_URL}wp-json/wp/v2/news/${to.params.id}`)
      .then((res) => {
        return res.data
      })

    // to.meta.breadCrumb.push({ label: data.title.rendered })
    to.meta.breadCrumb[1].label = data.title.rendered
    document.title = `${data.title.rendered} | ${document.title}`
  },
  setup() {
    const post = ref([])
    const lists = ref([])
    const route = useRoute()
    const ajax = axiosSetting('cms', 'block')

    const getPost = () => {
      ajax
        .get(
          `${process.env.VUE_APP_WPAPI_URL}wp-json/wp/v2/news/${route.params.id}`
        )
        .then((res) => {
          post.value = res.data
        })
    }

    const getLists = () => {
      ajax
        .get(`${process.env.VUE_APP_WPAPI_URL}wp-json/wp/v2/news?per_page=5`)
        .then((res) => {
          lists.value = res.data
        })
    }

    const formatDate = (date: string) => {
      const dt = new Date(date)
      const year = dt.getFullYear()
      const month = dt.getMonth() + 1
      const day = dt.getDate()

      return `${year}年${month}月${day}日`
    }

    getPost()
    getLists()

    watch(
      () => route.params.id,
      () => {
        if (route.params.id) getPost()
      }
    )

    return {
      post,
      lists,
      formatDate
    }
  }
}
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.news {
  padding-top: 27px;
  @include mixins.media() {
    display: grid;
    grid-template-columns: 1fr 242px;
    gap: 40px;
    // padding: 0 20px;
    // padding-right: 20px;
    // padding-left: 20px;
    padding: 35px 20px 0;
    max-width: 1128px;
    margin: 0 auto;
  }
}

.primary {
  padding: 0 16px;
  // margin-bottom: 48px;
  @include mixins.media() {
    padding: 0;
    // margin-bottom: 0;
  }
}

h1 {
  font-size: 2.2rem;
  font-weight: normal;
  line-height: 1.5;
  margin-bottom: 20px;
  // @include mixins.media() {
  //   margin-bottom: 19px;
  // }
}
.primary > time {
  display: block;
  margin-bottom: 31px;
}
.primary > img {
  display: block;
  margin: 0 auto 20px;
}

.content {
  margin-bottom: 32px;
  @include mixins.media() {
    margin-bottom: 46px;
  }
}

.primary > h2 {
  background-color: var.$color-sub-bg-g;
  font-size: 2rem;
  font-weight: normal;
  padding: 5px 16px;
  margin: 0 -16px;
  @include mixins.media() {
    margin: 0;
  }
}

.list {
  // margin-bottom: 4px;
  @include mixins.media() {
    border-bottom: 1px solid var.$color-border-gray;
    // margin-bottom: 32px;
  }
}

h3 {
  font-size: 1.4rem;
  font-weight: normal;
  line-height: 1.5;
  @include mixins.media() {
    line-height: 1.79;
  }
}

// .secondary {
// }
</style>
